const router = [
  {
    path: "/kelola/instansi/:instansi_id/angkatan",
    name: "angkatan",
    meta: {
      auth: true,
      module: "Kelola Kelas"
    },
    component: () => import("./pages/List.vue")
  },
];

export default router;
